import React, { Component } from 'react';
import classNames from 'classnames';
import isString from 'lodash/isString';
import { RegionType } from './RegionType.enum';

const splitterSize = 3;

export class Splitter extends Component {
	constructor(props) {
		super(props);

		const { getRegionHeight, getRegionWidth } = props.layoutContext;
		const screenWidth = window.innerWidth || 0;
		const posY = getRegionHeight(RegionType.North);
		const posX =
			props.region === RegionType.West
				? getRegionWidth(props.region)
				: screenWidth - getRegionWidth(props.region);

		this.state = {
			// `true` to start dragging the splitter
			isDragging: false,

			// the position of the splitter in x-axis
			posX,

			// the position of the splitter in y-axis
			posY,

			// the distance in x-axis between the splitter's starting position (posX) and the cursor position
			deltaX: 0,
		};

		document.addEventListener('mousemove', this.onDragging);
		document.addEventListener('mouseup', this.onDragEnd);
	}

	componentWillUnmount() {
		document.removeEventListener('mousemove', this.onDragging);
		document.removeEventListener('mouseup', this.onDragEnd);
	}

	// 'mousedown' event handler
	onDragStart = event => {
		const { clientX } = event;

		this.setState(prevState => ({
			isDragging: true,
			deltaX: clientX - prevState.posX,
		}));

		event.preventDefault();
	};

	// 'mousemove' event handler
	onDragging = event => {
		const { isDragging } = this.state;

		if (isDragging === true) {
			// check if the movement is within the boundaries (min <= clientX <= max)
			const clientX = this.calculatePosFromBoundaries(event.clientX);

			this.setState(prevState => ({
				posX: clientX - prevState.deltaX,
			}));
		}
	};

	// 'mouseup' event handler
	onDragEnd = () => {
		const { isDragging } = this.state;

		if (isDragging) {
			this.setState({ isDragging: false }, () => {
				const { region, layoutContext } = this.props;
				layoutContext.resize({ ...this.state, region });
			});
		}
	};

	calculatePosFromBoundaries(pos) {
		const screenWidth = window.innerWidth;
		const { region, layout } = this.props;
		const { minWidth = 0, maxWidth = 99999 } = layout;

		if (region === RegionType.West) {
			return Math.max(Math.min(pos, maxWidth), minWidth);
		} else if (region === RegionType.East) {
			return Math.max(Math.min(pos, screenWidth - minWidth), screenWidth - maxWidth);
		} else {
			return pos;
		}
	}

	render() {
		const { className, region } = this.props;
		const { posX, posY, isDragging } = this.state;
		const baseClassName = {
			'east-collapsible-panel-splitter': region === RegionType.East,
			'west-collapsible-panel-splitter': region === RegionType.West,
			active: isDragging === true,
			[className]: isString(className) && className !== '',
		};
		const splitterClassName = classNames('common-layout splitter', baseClassName);
		const splitterMaskClassName = classNames('common-layout splitter-mask', baseClassName);

		return (
			<>
				{/* this div layer is used to prevent from text selection or css :hover triggered with the cursor drag */}
				{isDragging === true && <div className={splitterMaskClassName} />}

				<div
					className={splitterClassName}
					style={{
						position: 'absolute',
						top: `${posY}px`,
						left: `${posX}px`,
						width: `${splitterSize}px`,
						height: `calc(100% - ${posY}px)`,
					}}
					onMouseDown={this.onDragStart}
					role="presentation"
				/>
			</>
		);
	}
}
